import React, {useState, useEffect} from 'react';
import api from '../contexts/BaseUrl'
import './Purchase.css'
import LeftPanel from '../components/LeftPanel';
import SearchIcon from '../icons/SearchIcon';
import CrossIcon from '../icons/CrossIcon';
import {Spinner} from 'react-activity'
import "react-activity/dist/library.css";
import Loading from '../components/Loading';
import { useCallback } from 'react';


function Purchase(){

    const token = JSON.parse(localStorage.getItem('auth')).token;
    

    const [addSale, setAddSale ]= useState(0);
    const [editSale,setEditSale] = useState(0);
    const [editSaleDetails, setEditSaleDetails] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isDeleteError, setIsDeleteError] = useState(false);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [isEditLoading, setIsEditLoading] = useState(false);

    const [allSales, setAllSales] = useState([]);
    const [saleId, setSaleId] = useState(0);

    //search variable
    const [searchSalesAssignedTo, setSearchSalesAssignedTo] = useState('');
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('');
    const [fullPaid, setFullPaid] = useState('');

    const dateFromObj = dateFrom ? new Date(dateFrom) : null;
    const dateToObj = dateTo ? new Date(dateTo) : null;
    
    const [pageNumber, setPageNumber] = useState(1);
    const [pagination, setPagination] = useState([]);

    //add new sale variable
    const [selectedDate, setSelectedDate] = useState('');
    const selectedDateObj = selectedDate ? new Date(selectedDate) : null;
    
    
    const [materialsName, setMaterialsName] = useState('');
    const [quantity, setQuantity] = useState('');
    const [totalPrice,setTotalPrice] = useState();
    const [amountPaid,setAmountPaid] = useState();
    const [totalPaid, setTotalPaid] = useState('');
    const [note, setNote] = useState('');


  
    var url;

    if(dateFromObj != null && dateToObj != null && searchSalesAssignedTo.length>0){
        if(fullPaid.length > 0){
            url = `rawmaterialsexpenses/get-all-materials-expense?materialsTotalPaid=${fullPaid}&materialsName=${searchSalesAssignedTo}&materialsFromDate=${dateFrom}&materialsToDate=${dateTo}&pageNumber=${pageNumber}&pageSize=40`
        }else{
            url = `rawmaterialsexpenses/get-all-materials-expense?materialsName=${searchSalesAssignedTo}&materialsFromDate=${dateFrom}&materialsToDate=${dateTo}&pageNumber=${pageNumber}&pageSize=40`
        }
        
    }
    else if(dateFromObj != null && dateToObj != null){
        if(fullPaid.length > 0){
            url = `rawmaterialsexpenses/get-all-materials-expense?materialsTotalPaid=${fullPaid}&materialsFromDate=${dateFrom}&materialsToDate=${dateTo}&pageNumber=${pageNumber}&pageSize=40`
        }else{
            url = `rawmaterialsexpenses/get-all-materials-expense?materialsFromDate=${dateFrom}&materialsToDate=${dateTo}&pageNumber=${pageNumber}&pageSize=40`
        }
        
    }
    else if(dateFromObj != null && searchSalesAssignedTo.length>0){
        if(fullPaid.length > 0){
            url = `rawmaterialsexpenses/get-all-materials-expense?materialsTotalPaid=${fullPaid}&materialsName=${searchSalesAssignedTo}&materialsFromDate=${dateFrom}&pageNumber=${pageNumber}&pageSize=40`
        }else{
            url = `rawmaterialsexpenses/get-all-materials-expense?materialsName=${searchSalesAssignedTo}&materialsFromDate=${dateFrom}&pageNumber=${pageNumber}&pageSize=40`
        }
        
    }
    else if(dateFromObj != null){
        if(fullPaid.length > 0){
            url = `rawmaterialsexpenses/get-all-materials-expense?materialsTotalPaid=${fullPaid}&materialsFromDate=${dateFrom}&pageNumber=${pageNumber}&pageSize=40`
        }else{
            url = `rawmaterialsexpenses/get-all-materials-expense?materialsFromDate=${dateFrom}&pageNumber=${pageNumber}&pageSize=40`
        }
        
    }
    else if(searchSalesAssignedTo.length>0){
        if(fullPaid.length > 0){
            url = `rawmaterialsexpenses/get-all-materials-expense?materialsTotalPaid=${fullPaid}&materialsName=${searchSalesAssignedTo}&pageNumber=${pageNumber}&pageSize=40`
        }else{
            url = `rawmaterialsexpenses/get-all-materials-expense?materialsName=${searchSalesAssignedTo}&pageNumber=${pageNumber}&pageSize=40`
        }
       
    }
    else{
        if(fullPaid.length > 1){
            url = `rawmaterialsexpenses/get-all-materials-expense?materialsTotalPaid=${fullPaid}&pageNumber=${pageNumber}&pageSize=20` ;
        }else{
            url = `rawmaterialsexpenses/get-all-materials-expense?pageNumber=${pageNumber}&pageSize=20` ;
        }
        
    }


    const handlePageNext = () =>{
        if(pagination.totalPages>pagination.currentPage){
            setPageNumber(pageNumber+1)
        }     
    }

    const handlePagePrevious = () =>{
        if(pageNumber>1){
            setPageNumber(pageNumber-1);
        }
    }

   
    const fetchAllDailyExpenses = useCallback( async () => {
        setIsLoading(true);
        await api.get(url,{
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            setAllSales(response.data);
            setIsLoading(false);
            setPagination(JSON.parse(response.headers.pagination));
        }).catch(err =>{
            setIsLoading(false);
        })
    },[url, token])

    const fetchDailyExpenseDetails = (e) => {
        setIsEditLoading(true);
        api.get(`rawmaterialsexpenses/get-material-expense-details?expenseId=${e}`,{
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            setSaleId(response.data.expenseRawMaterialsId);
            setSelectedDate(response.data.expenseRawMaterialsDate);
            setMaterialsName(response.data.expenseRawMaterialsName);
            setQuantity(response.data.expenseRawMaterialsQuantity);
            setTotalPrice(response.data.expenseRawMaterialsTotalPrice);
            setAmountPaid(response.data.expenseRawMaterialsAmountPaid);
            setTotalPaid(response.data.expenseRawMaterialsTotalPaid);
            setNote(response.data.expenseRawMaterialsNote);
            setIsEditLoading(false);
        }).catch(err =>{
            setIsEditLoading(false);
        })
    }

    useEffect(() => {
        fetchAllDailyExpenses();
    },[fetchAllDailyExpenses])

    const handleAddSales = async (e) => {
        
        e.preventDefault();
        setIsLoading(true);

        await api.post(`rawmaterialsexpenses/create-materials-expense`,{
            expenseRawMaterialsDate: selectedDateObj,
            expenseRawMaterialsName: materialsName,
            expenseRawMaterialsQuantity: quantity,
            expenseRawMaterialsTotalPrice: totalPrice,
            expenseRawMaterialsAmountPaid: amountPaid,
            expenseRawMaterialsTotalPaid: totalPaid,
            expenseRawMaterialsNote: note

        },{
            headers:{
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            fetchAllDailyExpenses();
            setIsLoading(false);
            setSelectedDate('');
            setMaterialsName('');
            setQuantity('');
            setTotalPrice();
            setAmountPaid();
            setTotalPrice('');
            setFullPaid('');
            setNote('');
            setAddSale(0);
        }).catch(err =>{
            setIsError(true);
            setIsLoading(false);
            setSelectedDate('');
            setMaterialsName('');
            setQuantity('');
            setTotalPrice();
            setAmountPaid();
            setTotalPaid('');
            setFullPaid('');
            setNote('');
        })
    }

    const showEditSale = (e) => {
        fetchDailyExpenseDetails(e);
        setEditSaleDetails(1);
    }

    const closeEditSale = () => {
        setSelectedDate('');
        setMaterialsName('');
        setQuantity('');
        setTotalPrice();
        setAmountPaid();
        setTotalPaid('');
        setFullPaid('');
        setNote('');
        setIsEditLoading(false);
        fetchAllDailyExpenses();
        setEditSaleDetails(0);
    }

    const handleEditSale = async (e) => {
        e.preventDefault();
        setIsEditLoading(true);
        await api.post(`rawmaterialsexpenses/edit-materials-expense`,{
            expenseRawMaterialsId: saleId,
            expenseRawMaterialsName: materialsName,
            expenseRawMaterialsQuantity: quantity,
            expenseRawMaterialsTotalPrice: totalPrice,
            expenseRawMaterialsAmountPaid: amountPaid,
            expenseRawMaterialsTotalPaid: totalPaid,
            expenseRawMaterialsNote: note
        },{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            setSelectedDate('');
            setMaterialsName('');
            setQuantity('');
            setTotalPrice();
            setAmountPaid();
            setTotalPaid('');
            setFullPaid('');
            setNote('');
            setIsEditLoading(false);
            fetchAllDailyExpenses();
            setEditSaleDetails(0);
        }).catch(err => {
            setIsError(true);
            setIsEditLoading(false);
            setSelectedDate('');
            setMaterialsName('');
            setQuantity('');
            setTotalPrice();
            setAmountPaid();
            setTotalPaid('');
            setFullPaid('');
            setNote('');
        })
    }

    const handleDeleteSale = async (e) => {
        e.preventDefault();
        setIsDeleteLoading(true);
        await api.post(`rawmaterialsexpenses/delete-materials-expense`,{
            materialsExpenseId: saleId,
        },{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            setSelectedDate('');
            setMaterialsName('');
            setQuantity('');
            setTotalPrice();
            setAmountPaid();
            setTotalPaid('');
            setFullPaid('');
            setNote('');
            setIsDeleteLoading(false);
            fetchAllDailyExpenses();
            setEditSaleDetails(0);
        }).catch(err => {
            setIsDeleteError(true);
            setIsDeleteLoading(false);
            setSelectedDate('');
            setMaterialsName('');
            setQuantity('');
            setTotalPrice();
            setAmountPaid();
            setTotalPaid('');
            setFullPaid('');
            setNote('');
        })
    }
 
    return(
        <div className='purchasePage'> 
    
           <LeftPanel 
                tabName='purchase'
           />
           <div id='rightPanel'>
                <div id='rightPanelContent'>
                    <div id='searchAddBox'>
                        <div className='dateBox'>
                            <input
                                type='date' 
                                className='dateInput'
                                onChange={e => setDateFrom(e.target.value)}
                                value={dateFrom}
                            />
                            <div id='to'>To</div>
                            <input
                                type='date' 
                                className='dateInput'
                                onChange={e => setDateTo(e.target.value)}
                                value={dateTo}
                            />

                            <div id='searchBox'>
                                <SearchIcon 
                                    size='24' 
                                    style={{
                                        paddingLeft:10,
                                        paddingTop:8,
                                        position:'absolute',
                                    }} 
                                    color='gray'
                                />
                                <input
                                    placeholder='Search by Purchase Name'
                                    id='searchSales'
                                    onChange={(e) => setSearchSalesAssignedTo(e.target.value)}
                                    value={searchSalesAssignedTo}
                                />
                            </div>

                            <select 
                                id='chooseSelect' 
                                required
                                onChange={(e) => setFullPaid(e.target.value)}
                                value={fullPaid}
                            >
                                <option value=''>Full Paid?</option>
                                <option value='Yes'>Yes Paid</option>
                                <option value='No'>No Paid</option>
                            </select>
                        </div>
                       <div>{
                           editSale === 0 ?
                           <button 
                                id='editButton'
                                onClick={() => setEditSale(1)}
                            >Edit Purchase</button>
                       :
                            <button 
                                id='editCancelButton'
                                onClick={() => setEditSale(0)}
                            >Cancel Edit</button>
                           }
                           
                            <button 
                                id='addButton'
                                onClick={() => setAddSale(1)}
                            >Add Purchase</button>
                       </div>
                        
                    </div>
                    <div id='tableBox'>
                        {isLoading ? 
                        <Loading /> :
                        <table>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Materials Name</th>
                                    <th>Quantity</th>
                                    <th>Total Price (Tk)</th>
                                    <th>Amount Paid (Tk)</th>
                                    <th>Full Paid</th>
                                    <th>Note</th>
                                    
                                    {editSale === 1 && <th>Actions</th>}
                                </tr>
                                
                            </thead>
                            <tbody>
                            {allSales.map((item, index) =>{
                                return(
                                    <tr key={index}>
                                        <td>{item.expenseRawMaterialsDate.substring(0, item.expenseRawMaterialsDate.length - 9)}</td>
                                        <td>{item.expenseRawMaterialsName}</td>
                                        <td>{item.expenseRawMaterialsQuantity}</td>
                                        <td>{item.expenseRawMaterialsTotalPrice}</td>
                                        <td>{item.expenseRawMaterialsAmountPaid}</td>
                                        <td>{item.expenseRawMaterialsTotalPaid}</td>
                                        <td>{item.expenseRawMaterialsNote}</td>
                                        {editSale ===1 && <td onClick={() => showEditSale(item.expenseRawMaterialsId)} style={{cursor:'pointer'}}>Edit</td>}
                                        
                                    </tr>
                                )
                            })}
                            </tbody>

                        </table>
                    }
                    <div id='pageChangeBox'>
                        <div id='fixedBox'>
                            <button id='pageChangeButton' onClick={handlePagePrevious}>Back</button>
                            
                            <span>{pageNumber} / {pagination.totalPages}</span>
                            <button id='pageChangeButton' onClick={handlePageNext}>Next</button>
                        </div>    
                        
                    </div>
                    </div>
                </div>
           </div>
           {
               addSale === 1 && 
               <>
                <div id='darkBackground' />
                <div id='modal'>
                    <CrossIcon 
                        size='36'
                        style={{
                            position:'absolute',
                            right:0,
                            cursor:'pointer'
                        }}
                        onClick={()=>setAddSale(0)}
                    />
                    <form id='modalContent' onSubmit={handleAddSales}>
                        <div id='modalName'>Add New Purchase</div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='nameTitle'>Date:</div>
                                <input
                                    id='typeName'
                                    type='date'
                                    required
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                    value={selectedDate}
                                />
                            </div>
                            
                        </div>
                        
                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Materials Name:</div>
                                <input
                                    id='typeDesignation'
                                    placeholder='Type materials name'
                                    required
                                    onChange={(e) => setMaterialsName(e.target.value)}
                                    value={materialsName}
                                />
                            </div>
                            <div id='name'>
                                <div id='header'>Quantity:</div>
                                <input
                                    id='typeQuantity'
                                    placeholder='Type quantity'
                                    required
                                    onChange={(e) => setQuantity(e.target.value)}
                                    value={quantity}
                                />
                            </div>
                        </div>

                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Total Price(Tk): </div>
                                <input
                                    id='typeAmount'
                                    type='number'
                                    placeholder='Type amount paid'
                                    required
                                    onChange={(e) => setTotalPrice(e.target.value)}
                                    value={totalPrice}
                                />
                            </div>   
                            <div id='name'>
                                <div id='header'>Amount Paid(Tk): </div>
                                <input
                                    id='typeAmount'
                                    type='number'
                                    placeholder='Type amount paid'
                                    required
                                    onChange={(e) => setAmountPaid(e.target.value)}
                                    value={amountPaid}
                                />
                            </div>   
                        </div>

                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Total Paid:</div>
                                <select 
                                    id='statusSelect' 
                                    required
                                    onChange={(e) => setTotalPaid(e.target.value)}
                                    value={totalPaid}
                                >
                                    <option value=''>Choose</option>
                                    <option value='Yes'>Yes</option>
                                    <option value='No'>No</option>
                                </select>
                            </div>
                            <div id='name'>
                                <div id='header'>Note:</div>
                                <input
                                    id='typeDesignation'
                                    placeholder='Type note here'
                                    onChange={(e) => setNote(e.target.value)}
                                    value={note}
                                />
                            </div>
                        </div>
                      
                        {isError && 
                            <div id='errorMsg'>Failed adding new purchase! Please try again later.</div>
                        }
                        {isLoading ? 
                    <button id='addEmployee'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                    <button id='addEmployee'>Add Purchase</button>
                    }
                       
                    </form>
                </div>
               </>
           }
            {
               editSaleDetails === 1 && 
               <>
                <div id='darkBackground' />
                <div id='modal'>
                    {isEditLoading ? 
                    <Loading /> :
                    
                    <div>
                    <CrossIcon 
                        size='36'
                        style={{
                            position:'absolute',
                            right:0,
                            top:0,
                            cursor:'pointer'
                        }}
                        onClick={closeEditSale}
                    />
                    <form id='modalContent' onSubmit={handleEditSale}>
                        <div id='modalName'>Edit Purchase</div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='nameTitle'>Date:</div>
                                <div>{selectedDate.substring(0,selectedDate.length-9)}</div>
                            </div>
                           
                        </div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Materials Name:</div>
                                <input
                                    id='typeDesignation'
                                    placeholder='Type materials name'
                                    required
                                    onChange={(e) => setMaterialsName(e.target.value)}
                                    value={materialsName}
                                />
                            </div>
                            <div id='name'>
                                <div id='header'>Quantity:</div>
                                <input
                                    id='typeQuantity'
                                    placeholder='Type quantity'
                                    required
                                    onChange={(e) => setQuantity(e.target.value)}
                                    value={quantity}
                                />
                            </div>   
                        </div>
                        
                      
                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Total Price(Tk): </div>
                                <input
                                    id='typeAmount'
                                    type='number'
                                    placeholder='Type amount paid'
                                    required
                                    onChange={(e) => setTotalPrice(e.target.value)}
                                    value={totalPrice}
                                />
                            </div>   
                            <div id='name'>
                                <div id='header'>Amount Paid(Tk): </div>
                                <input
                                    id='typeAmount'
                                    type='number'
                                    placeholder='Type amount paid'
                                    required
                                    onChange={(e) => setAmountPaid(e.target.value)}
                                    value={amountPaid}
                                />
                            </div>       
                        </div>

                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Total Paid:</div>
                                <select 
                                    id='statusSelect' 
                                    required
                                    onChange={(e) => setTotalPaid(e.target.value)}
                                    value={totalPaid}
                                >
                                    <option value=''>Choose</option>
                                    <option value='Yes'>Yes</option>
                                    <option value='No'>No</option>
                                </select>
                            </div>
                            <div id='name'>
                                <div id='header'>Note:</div>
                                <input
                                    id='typeDesignation'
                                    placeholder='Type note here'
                                    onChange={(e) => setNote(e.target.value)}
                                    value={note}
                                />
                            </div>
                        </div>
                     
                        {isError && 
                            <div id='errorMsg'>Failed updating expense! Please try again later.</div>
                        }
                        {isDeleteError && 
                            <div id='errorMsg'>Failed deleting expense! Please try again later.</div>
                        }
                        {isEditLoading ? 
                    <button id='addEmployee'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                    <button id='addEmployee'>Update Expense</button>
                    }
                    
                    </form>
                    {isDeleteLoading ?    
                        <button id='deleteSale'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                        <button id='deleteSale' onClick={handleDeleteSale} >Delete</button>
                    }
                    </div>
                    }
                </div>
               </>
           }
          

        </div>
    )
}

export default Purchase;